import { RootState } from "@/redux/store";

export const userAccountsSelector = (state: RootState) => state.userAccount.accounts;
export const userAccountsPageSelector = (state: RootState) => state.userAccount.page;
